enum AssistantName {
  CollectionCreator = "CollectionCreator",
  Factotum = "Factotum",
}
export default AssistantName;
